class Accordion {
    init() {
        app.events.sub(app.events.eventList.ready, function () {
            app.accordion.initPage();
        });
        app.events.sub(app.events.eventList.page_reload, function () {
            app.accordion.initPage();
        });
        app.events.sub(app.events.eventList.page_inject, function () {
            app.accordion.initInject();
        });

    }

    initPage() {
        if (this.initInject()) {
            if (window.location.hash.length) {
                let elem = document.getElementById(window.location.hash.substring(1));
                if (elem && elem.previousElementSibling) {
                    app.accordion.open(elem.previousElementSibling);
                }
                setTimeout(() => {
                    window.scrollTo(0, $(elem).offset().top);
                }, 100);
            } else {
                let elements = jQuery(".accordion-toggle.open");
                if (elements.length) {
                    elements.each(function (e) {
                        app.accordion.open(e);
                    });
                }
            }
        }
    }

    initInject() {
        const toggle = jQuery(".accordion-toggle:not(.init)");
        if (toggle.length) {
            toggle.addClass("init");
            toggle.on("click", function () {
                app.accordion.toggle(this);
            });
            const open = jQuery(".accordion-toggle.open");
            if (open.length) {
                open.each(function () {
                    $(this).removeClass("open");
                    $(this).click();
                })
            }
            return true;
        }
        return false;
    }

    hashChanged() {
        if (window.location.hash.length) {
            let elem = document.getElementById(window.location.hash.substring(1));
            if (elem && elem.previousElementSibling) {
                app.accordion.open(elem.previousElementSibling);
            }
        }
    }

    checkForOpen() {
        let elements = jQuery(".accordion-toggle.open");
        if (elements.length) {
            elements.each(function (e) {
                app.accordion.open(e);
            });
        }
    }

    toggle(elem) {
        let targets = this.findTargets(elem);
        if (targets.length) {
            if (targets.hasClass("open")) {
                targets.next().slideUp(100);
            } else {
                targets.next().slideDown(100);
            }
            targets.toggleClass("open");
        }
    }

    open(elem) {
        let targets = this.findTargets(elem);
        if (targets.length) {
            targets.next().slideDown(100);
            targets.addClass("open");
        }
    }

    findTargets(elem) {
        let targets;
        if (typeof elem == "string") {
            targets = jQuery("#" + elem).prev();
        } else {
            let link = jQuery(elem).data("accordion-link");
            if (link) {
                targets = jQuery("[data-accordion-link='" + link + "']");
            } else {
                targets = jQuery(elem);
            }
        }
        return targets;
    }
}